import { render, staticRenderFns } from "./ParcelamentoDasView.vue?vue&type=template&id=9d610606&"
import script from "./ParcelamentoDasView.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoDasView.vue?vue&type=script&lang=js&"
import style0 from "./ParcelamentoDasView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports